<template>
  <div class="apps">
    <div class="apps__subheader mb-4" v-if="!showForm">
        <add-button class="mr-4" @click="showAddForm"></add-button>
        <limit-component v-if="apps.length >= 10" v-model="limit" @input="getApps"></limit-component>
    </div>
    <spinner v-if="isBusy" />
    <div class="tech" v-show="!isBusy">
      <div class="apps__wrapper" v-if="!showForm">
        <custom-table v-if="$store.state.tableView.apps" class="mb-4" :rows="rows" :items="apps" :show-edit="false" @archive="archiveApp" @edit="showMoreForm">
          <template slot="icon" slot-scope="{ item }">
            <img class="apps__icon" :src="item.icon | prepareApiStaticPath" />
          </template>
          <template slot="title" slot-scope="{ item }">
            {{item.title}}<br>
            {{item.packageName}}
          </template>
          <template slot="version" slot-scope="{ item }">
            {{item.versionName}}<br>
            {{item.versionCode}}
          </template>
          <template slot="additionalFields" slot-scope="{ item }">
            <div v-for="field in item.additionalFields" :key="field.name" v-if="field.value">
              {{field.title}}: {{field.value}}
            </div>
          </template>
          <template slot="compile" slot-scope="{ item }">
            <div v-if="item.compileStatus === 'new'">
              <half-circle-spinner
                  class="spinner"
                  :animation-duration="1000"
                  :size="25"
                  color="#3d3df3"
              />
            </div>
            <div class="apps__download" v-else-if="item.compileStatus === 'error'">
              <div class="apps__download-buttons">
                <refresh-button @click="reCompileApp(item)"></refresh-button>
                <a  target="_blank" v-if="item.archiveDownloadRef && currentUser.role === 'ADMIN'" :href="item.archiveDownloadRef | prepareApiStaticPath">.zip</a><br>
              </div>
              <div v-if="item.compileErrorMessage" class="apps__error-msg mt-2">{{item.compileErrorMessage}}</div>
            </div>
            <div class="apps__download" v-else-if="item.compileStatus === 'done'">
              <a target="_blank" :href="item.apkDownloadRef | prepareApiStaticPath">.apk</a><br>
              <a v-if="currentUser.role === 'ADMIN'" target="_blank" :href="item.archiveDownloadRef | prepareApiStaticPath">.zip</a>
            </div>
          </template>
        </custom-table>
        <div class="apps__cards" v-if="!this.$store.state.tableView.apps && !showAppMore">
          <custom-card v-for="item in apps"
                        :key="item.id"
                        :item="item"
                        @show-more="showMoreForm(item)"
                        >
            <template slot="icon"><img class="apps__icon" :src="item.icon | prepareApiStaticPath" /></template>
            <template slot="title" @show-more="showMoreForm(item)">{{item.title}}<br>{{item.versionName}} / {{item.versionCode}}</template>
            <template slot="content"><span class="apps__slot-item">{{item.title}}</span><span class="apps__slot-item">{{item.packageName}}</span>
              <a class="apps__link mt-2 mb-2" :href="item.url" target="_blank">Оффер</a>
            <div v-if="item.compileStatus === 'new'">
              <half-circle-spinner
                  class="spinner"
                  :animation-duration="1000"
                  :size="25"
                  color="#3d3df3"
              />
            </div>
            <div class="apps__download card-view" v-else-if="item.compileStatus === 'error'">
                <refresh-button @click="reCompileApp(item)"></refresh-button>
                <error-button></error-button>
            </div>
            <div class="apps__download card-view" v-else-if="item.compileStatus === 'done'">
              <a target="_blank" :href="item.apkDownloadRef | prepareApiStaticPath">.apk</a><br>
              <a v-if="currentUser.role === 'ADMIN'" target="_blank" :href="item.archiveDownloadRef | prepareApiStaticPath">.zip</a>
            </div>
            </template>
          </custom-card>
        </div>
        <pagination v-if="totalPages > 1 && !showAppMore"
                    :page-count="totalPages"
                    :click-handler="onChangePage"
                    />
      </div>
      <app-more v-if="showAppMore"
                :app="appMore"
                 @close="showAppMore = false"
                 @archive="archiveApp"
      ></app-more>
      <app-form v-if="showForm"
                      :app="formApp"
                      @close="showForm = false"
                      @add = "addApp" />
    </div>
  </div>
</template>

<script>
  import CustomTable from './UIComponents/CustomTable';
  import CustomCard from './UIComponents/CustomCard';
  import Pagination from './UIComponents/Pagination';
  import LimitComponent from './UIComponents/LimitComponent';
  import AddButton from './UIComponents/AddButton';
  import ErrorButton from './UIComponents/ErrorButton';
  import refreshButton from './UIComponents/RefreshButton';
  import AppForm from './AppForm';
  import AppMore from './AppMore';
  import Spinner from './UIComponents/Spinner';
  import { HalfCircleSpinner } from 'epic-spinners';
  import { Auth } from '../api';

  let compileIntervalId;

  export default {
    components: {
      CustomTable,
      CustomCard,
      Pagination,
      LimitComponent,
      AddButton,
      ErrorButton,
      refreshButton,
      AppForm,
      AppMore,
      Spinner,
      HalfCircleSpinner
    },
    data() {
      return {
        apps: [],
        limit: 10,
        offset: 0,
        filter: {},
        totalRows: 0,
        rows: [
          { field: 'icon', label: '' },
          { field: 'title', label: 'Название', align: 'center' },
          { field: 'version', label: 'Версия', align: 'center' },
          { field: 'url', label: 'Офферная ссылка', align: 'center' },
          { field: 'backendTemplateTitle', label: 'Шаблон', align: 'center' },
          { field: 'additionalFields', label: 'Дополнительно', align: 'center' },
          { field: 'compile', label: '', },
        ],
        showForm: false,
        formApp: {},
        isBusy: true,
        appMore: {},
        showAppMore: false,
        currentUser: Auth.user
      }
    },
    computed: {
      totalPages: function () {
        return Math.ceil(this.totalRows / this.limit);
      }
    },
    watch: {
      '$store.state.search': function(search) {
        this.filter.search = search;
        this.getApps();
      }
    },
    methods: {
      showAddForm() {
        this.formApp = {};
        this.showForm = true;
      },
      showMoreForm(app) {
        this.appMore = app;
        this.showAppMore = true;
      },
      addApp(app) {
        this.isBusy = true;
        let { formData, headers } = this.constructFormDataRequest(app);
        return this.$API.post('app', formData, { headers })
          .then(() => {
            this.showForm = false;
            this.$notify({ type: 'success', message: 'Приложение успешно добавлено!' });
            this.getAppsAndHandleCompile();
          })
          .catch(() => {
            this.isBusy = false;
          })
      },
      archiveApp(app) {
        this.isBusy = true;
        this.showAppMore = false;
        return this.$API.put(`app/${app.id}`, { deleted: 1 })
          .then(() => {
            this.$notify({ type: 'success', message: 'Приложение успешно архивировано!' });
            return this.getAppsAndHandleCompile();
          })
          .catch(() => {
            this.isBusy = false;
          })
      },
      reCompileApp(app) {
        this.isBusy = false;
        return this.$API.patch(`app/${app.id}`)
          .then(() => {
            this.$notify({ type: 'success', message: 'Приложение отправлено на перекомпиляцию!' });
            return this.getAppsAndHandleCompile();
          })
          .catch(() => {
            this.isBusy = false;
          })
      },
      onChangePage(page) {
        this.offset = (page - 1) * this.limit;
        this.getAppsAndHandleCompile();
      },
      getApps(showBusy) {
        if (showBusy)
          this.isBusy = true;
        return this.$API.get('apps', { params: { ...this.filter, limit: this.limit, offset: this.offset } })
          .then(response => {
            this.apps = response.data.rows;
            this.totalRows = response.data.count;
            if (showBusy)
              this.isBusy = false;
          });
      },
      getAppsAndHandleCompile(showBusy = true) {
        if (compileIntervalId)
          clearInterval(compileIntervalId);
        return this.getApps(showBusy)
          .then(() => {
            let isCompile = false;
            for (let app of this.apps) {
              isCompile = app.compileStatus === 'new';
              if (isCompile)
                break;
            }
            if (isCompile)
              compileIntervalId = setInterval(() => this.getAppsAndHandleCompile(false), 3000);
          })
      },
      constructFormDataRequest(obj) {
        let formData = new FormData();
        Object.keys(obj).forEach(key => {
          if (key === 'additionalFields') {
            obj[key].forEach(field => {
              formData.append(`${key}[${field.name}]`, field.value);
            });
            return;
          }
          if (['deleted'].includes(key) && !obj[key])
            return;
          formData.append(key, obj[key] || '');
        });
        let headers = { 'Content-Type': 'multipart/form-data' };
        return { formData, headers };
      }
    },
    mounted() {
      this.getAppsAndHandleCompile();
    },
    created() {
      if (window.innerWidth <= 780) {
        this.$store.commit("mobileSettings",this.$route.name)
      }
    }
  }
</script>

<style lang="scss">
@import '../styles/variables.scss';
  .apps {
    position: relative;

    &__subheader {
      display: flex;
      align-items: center;
    }

    &__cards {
      position: relative;
      display: flex;
      flex-wrap: wrap;
      width: 100%;

      @media screen and (max-width: 870px) {
        justify-content: center;
      }
    }

    &__icon {
      margin: 5px 5px;
      display: inherit;
      width: 80px;
      height: 80px;
    }

    &__slot-item {
      text-align: left;
      word-break: break-all;
    }

    &__download {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;

      &.card-view {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        width: 60px;
      }

      a {
        height: 25px;
        color: $main-blue;
      }
    }

    &__link {
      color: $main-blue;
      text-align: left;

    .dark & {
		    color: $dark-text;
	    }
    }

    &__error-msg {
      display: block;
      max-height: 100px;
      max-width: 250px;
      word-wrap: break-word;
      padding: 0 10px;
      overflow-y: auto;

      &.card-view {
        position: relative;
        background-color: red;
        overflow: visible;
        z-index: 3;
      }
    }
  }
</style>
